

























































import { Component, Vue } from 'vue-property-decorator'

// import SearchInput from '@/components/SearchInput/index.vue'
import CityIndexSearchBox from '@/components/CityIndexSearchBox/index.vue'
import FiltrateBox from '@/components/FiltrateBox/index.vue'
import ProductList from '@/components/ProductList/index.vue'
import Sort from '@/components/Sort/index.vue'
import { custProductTypies } from '@/api/com'
import { productSearch, products } from '@/api/product'

@Component({
  name: 'Search',
  components: {
    // SearchInput,
    CityIndexSearchBox,
    // Filtrate,
    FiltrateBox,
    ProductList,
    Sort
  }
})
export default class Search extends Vue {
  // 产品数据
  dataList:any[] = []

  // 数据总条数
  sizeAll = 0

  // 当前页数
  page = 1

  // 每一页的多少条数据
  resultNum = 20

  // 产品数据加载状态
  loading = false

  areaId: number | string = ''

  treeId: number | string = ''

  // 1 推荐值 2 销量 3 发布时间 4 利润
  sortActive: number | string = 1

  // 排序方式 0升序 1 降序
  sortType: number | string = 1
  // 最小金额
  minPrice: number | string = ''
  // 最大金额
  maxPrice: number | string = ''

  keyword = ''

  // 产品分类初始数据
  productTags: any[] = []

  tagIds = ''

  labelId = ''
  // type = 1:百灵文旅, tagId=296:春季踏青活动专区
  private type = 0

  handleSearch () {
    this.getProductSearch(true)
  }

  changeSort (item): void {
    this.sortActive = item.id
    this.sortType = item.sortType
    this.getProductSearch(true)
  }

  // 类别切换
  changeType (item): void {
    this.tagIds = ''
    this.treeId = item
    this.getProductSearch(true)
  }

  // 切换城市
  changeCity (item: number): void {
    this.areaId = item
    this.getProductSearch(true)
  }

  // 切换分页
  currentChange (item) {
    this.page = item
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getProductSearch()
  }

  // 切换分类
  private handleChangeRadio (item) {
    this.labelId = item
    this.getProductSearch(true)
  }

  // 筛选项切换
  private changeFiltrate (item) {
    console.log(item, '切换')
    this.minPrice = item.minPrice
    this.maxPrice = item.maxPrice
    this.tagIds = item.tagIds
    if (item.clear) {
      this.sortActive = 1
      this.sortType = 0
      this.labelId = item.labelId
    }

    if (window.__time__Timeout_ || this.loading) {
      clearTimeout(window.__time__Timeout_)
      window.__time__Timeout_ = null
    }
    window.__time__Timeout_ = setTimeout(() => {
      this.getProductSearch(true)
      clearTimeout(window.__time__Timeout_)
    }, 600)
  }

  // 获取产品类型-分类 treeId
  getCustProductTypies ():void {
    custProductTypies()
      .then((res: any) => {
        if (res) {
          const arr: any[] = res || []
          arr.unshift({
            id: 99,
            name: '全部'
          })
          this.productTags = arr
        }
      })
  }

  // 获取搜索的产品数据
  getProductSearch (autoCount?: boolean): void {
    this.loading = true
    const params = {
      autoCount: true,
      areaId: this.areaId,
      keyword: encodeURIComponent(this.keyword),
      minPrice: this.minPrice,
      maxPrice: this.maxPrice,
      page: this.page,
      resultNum: this.resultNum,
      sort: this.sortActive,
      sortType: this.sortType || 0,
      treeId: this.treeId === 99 ? '' : this.treeId,
      tagIds: this.tagIds,
      labelId: this.labelId
    }
    let api: any = ''
    if (this.type === 1) {
      api = products
    } else {
      api = productSearch
    }
    api(params)
      .then(res => {
        this.loading = false
        if (res) {
          if (autoCount) this.sizeAll = res.sizeAll
          this.dataList = res.results || []
        }
      })
  }

  // @Watch('$route')
  // setRouteActive (): void {
  //   this.$router.go(0)
  // }

  mounted (): void {
    const { sort, key, labelId, tagIds, type } = this.$route.query
    if (typeof sort !== 'undefined') {
      this.sortActive = Number(sort)
    }
    if (typeof key === 'string') {
      this.keyword = key
    }
    if (type) {
      this.type = Number(type)
    }
    this.getCustProductTypies()
    if (!labelId && !tagIds) this.getProductSearch(true)
  }
}
